import { render } from "./AuszahlungErrors.pug?vue&type=template&id=32fc151b&lang=pug"
import script from "./AuszahlungErrors.js?vue&type=script&lang=js"
export * from "./AuszahlungErrors.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__